import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./expeditionProcessForm.data.form";
import InputDate from "../../../utils/InputDate";
import InputSelect from "../../../utils/InputSelect";
import { VARIETIES } from "../../../../constants/index";
import InputText from "../../../utils/InputText";

const ExpeditionProcessForm = (props) => {
  const { t } = useTranslation();
  const { handleSubmit, onback } = props;

  return (
    <>
      <div className="row justify-content-center mt-md-0">
        <div className="col-12 col-md-11">
          <h3 className="title">{t("forms.expeditionProcess.titleNew")}</h3>
        </div>
      </div>
      {/* <BreadCrumb items={breads} /> */}
      <div className="row justify-content-center mt-2">
        <div className="col-12 col-md-11">
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="row mt-2">
              <div className="col-6">
                <Field
                  id="article"
                  className="form-control"
                  labelField={t("forms.expeditionProcess.labels.article")}
                  name="article"
                  component={InputText}
                  fieldType="text"
                  placeholder=""
                  mandatory
                />
              </div>

              {/* <div className="col-12 col-md mt-2">
                <Field
                  id="article"
                  className="form-control"
                  labelField={t("forms.expeditionProcess.labels.article")}
                  name="article"
                  component={InputText}
                  fieldType="text"
                  placeholder=""
                />
              </div> */}
              <div className="col-6 col-md mt-2">
                <Field
                  id="dateInit"
                  labelField={t("forms.expeditionProcess.labels.dateInitNew")}
                  className="form-control"
                  name="dateInit"
                  component={InputDate}
                  language="es"
                  dateFormat="dd/MM/yyyy"
                  mandatory
                  defaultHours={12}
                  defaultMinutes={10}
                />
              </div>
            </div>
            <div className="row mt-2">
              {/* <div className="col-6 col-md mt-2">
                <Field
                  id="code"
                  className="form-control"
                  labelField={t("forms.expeditionProcess.labels.code")}
                  name="code"
                  component={InputText}
                  fieldType="text"
                  mandatory
                  placeholder=""
                />
              </div> */}
              <div className="col-6 col-md mt-2">
                <Field
                  id="batchOut"
                  className="form-control"
                  labelField={t("forms.expeditionProcess.labels.batchOut")}
                  name="batchOut"
                  component={InputText}
                  fieldType="text"
                  mandatory
                  placeholder=""
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-6 col-md mt-2">
                <Field
                  id="type"
                  className="form-control"
                  labelField={t("forms.expeditionProcess.labels.type")}
                  name="type"
                  component={InputText}
                  fieldType="text"
                  placeholder=""
                />
              </div>
              <div className="col-6 col-md mt-2">
                <Field
                  id="priority"
                  className="form-control"
                  labelField={t("forms.expeditionProcess.labels.priority")}
                  name="priority"
                  component={InputText}
                  fieldType="text"
                  placeholder=""
                />
              </div>
              {/* <div className="col-12">
                <Field
                  id="variety"
                  name="variety"
                  labelField={t("forms.expeditionProcess.labels.variety")}
                  // className="form-control"
                  component={InputSelect}
                  placeholder=""
                  optionLabel="label"
                  optionValue="code"
                  options={VARIETIES.map((item) => ({
                    ...item,
                    label: t(item.label),
                  }))}
                  addOptionEmpty
                  classNamePrefix="dark"
                />
              </div> */}
            </div>

            <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-5">
                <button
                  type="button"
                  onClick={() => onback("ModalForm")}
                  className="btn btn-lg btn-secondary me-2"
                >
                  {t("forms.expeditionProcess.buttons.cancel")}
                </button>
                <button type="submit" className="btn btn-lg btn-primary">
                  {t("forms.expeditionProcess.buttons.save")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

ExpeditionProcessForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onback: PropTypes.func,
  edit: PropTypes.bool,
};

const ExpeditionProcessFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "ServiceForm",
})(ExpeditionProcessForm);

export default ExpeditionProcessFormF;
